module.exports = __webpack_public_path__ + "images/user-icon-36f082ce79be3668615da1022f604b87.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/user-icon.png
// module id = ./client/assets/images/user-icon.png
// module chunks = 5 7 8 11 12 13